import { useQuery } from '@tanstack/react-query'
import { getAllUsersAuth0 } from 'api/auth0Api'

export const useGetAllUsersAuth0 = () => {
  return useQuery({
    queryKey: ['users-auth0'],
    queryFn: getAllUsersAuth0,
  })
}
